const categories = [
  { name: '国产剧全集', desc: '最新热门国产剧一网打尽', icon: 'ri-movie-2-line', count: '320+ 部' },
  { name: '韩剧全集', desc: '高分韩剧免费在线观看', icon: 'ri-heart-pulse-line', count: '180+ 部' },
  { name: '美剧全集', desc: '经典美剧高清流畅播放', icon: 'ri-global-line', count: '250+ 部' },
  { name: '日剧全集', desc: '日剧资源每日同步更新', icon: 'ri-sun-line', count: '160+ 部' },
  { name: '动漫专区', desc: '热门动漫全集随时追', icon: 'ri-ghost-line', count: '200+ 部' },
  { name: '综艺节目', desc: '热门综艺节目在线看', icon: 'ri-tv-2-line', count: '150+ 部' },
  { name: '纪录片库', desc: '优质纪录片深度观看', icon: 'ri-earth-line', count: '100+ 部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block text-xs font-medium text-secondary-600 bg-secondary-100 px-3 py-1 rounded-full mb-3">
              分类导航
            </span>
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
              剧集分类
            </h2>
            <p className="text-sm text-foreground-500 mt-2">按类型浏览你感兴趣的剧集</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
            {categories.map((cat, i) => (
              <a
                key={i}
                href="#index"
                className="group flex flex-col items-center text-center p-5 md:p-6 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-primary-100 text-primary-600 rounded-xl mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${cat.icon} text-xl`}></i>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1 font-heading">{cat.name}</h3>
                <p className="text-xs text-foreground-500 mb-2">{cat.desc}</p>
                <span className="text-xs text-primary-600 font-medium">{cat.count}</span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}